import { PluddaDetailsComponent } from "./pludda/pludda-details/pludda-details.component";
import { PluddaComponent } from "./pludda/pludda.component";
import { MyAssetRideHistoryComponent } from "./my-asset-ride-history/my-asset-ride-history.component";
import { BoundaryComponent } from "./geofence-list/boundary/boundary.component";
import { GeofenceListComponent } from "./geofence-list/geofence-list.component";
import { GeofenceMapComponent } from "./geofence-map/geofence-map.component";
import { Routes } from "@angular/router";

import { TermConditionsComponent } from "./term-conditions/term-conditions.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { ProfileComponent } from "./profile/profile.component";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";
import { FaqComponent } from "./faq/faq.component";

import { TransactionsComponent } from "./transactions/transactions.component";
import { CustomerReviewComponent } from "./customer-review/review.component";

import { RideHistoryComponent } from "./ride-history/ride-history.component";
import { PurchaseHistoryComponent } from "./purchase-history/purchase-history.component";
import { NotificationsComponent } from "./notifications/notifications.component";
import { OperatorSupportComponent } from "./operator-support/operator-support.component";
import { FeedbackComponent } from "./feedback/feedback.component";
import { MyAssetsComponent } from "./my-assets/my-assets.component";
import { DetailmyassetComponent } from "./my-assets/detailmyasset/detailmyasset.component";
import { BusinessProfileComponent } from "./business-profile/business-profile.component";
import { RentPackageComponent } from "./rent-package/rent-package.component";
import { LeasePackageComponent } from "./lease-package/lease-package.component";
import { SalePackageComponent } from "./sale-package/sale-package.component";
import { TrackAssetsComponent } from "./track-assets/track-assets.component";
import { PaymentMethodComponent } from "./payment-method/payment-method.component";
import { DetailsComponent } from "./ride-history/details/details.component";
import { RideDetailsComponent } from "./my-asset-ride-history/ride-details/ride-details.component";
import { OperationComponent } from "./operation/operation.component";
import { SubscriptionComponent } from "./subscription/subscription.component";
import { HomeComponent } from "./home/home.component";
import { AddPaymentComponent } from "./add-payment/add-payment.component";
import { WaiverComponent } from "./waiver/waiver.component";
import { CouponsComponent } from "./coupons/coupons.component";
import { UsedCouponsComponent } from "./used-coupons/used-coupons.component";
import { WaiverFormsComponent } from "./waiver-forms/waiver-forms.component";
import { ExternalApiComponent } from "./external-api/external-api.component";
import { FrekisTermComponent } from "./frekis-term/frekis-term.component";
import { SharekayakTermComponent } from "./sharekayak-term/sharekayak-term.component";
import { OdeTermComponent } from "./ode-term/ode-term.component";
import { ParkingViolationComponent } from "./parking-violation/parking-violation.component";
import { ParkingViolationDetailComponent } from "./parking-violation/parking-violation-detail/parking-violation-detail.component";
import { SaleCouponsComponent } from "./sale-coupons/sale-coupons.component";
import { LeaseCouponsComponent } from "./lease-coupons/lease-coupons.component";
import { LeaseHistoryComponent } from "./lease-history/lease-history.component";
import { LockFallbackComponent } from "./lock-fallback/lock-fallback.component";
import { RequestPaymentComponent } from "./request-payment/request-payment.component";
import { BusinessAnalyticsComponent } from "./my-assets/business-analytics/business-analytics.component";
import { AdvanceBookingComponent } from "./advance-booking/advance-booking.component";
import { TimeSlotComponent } from "./time-slot/time-slot.component";
import { UpcomingBookingComponent } from "./upcoming-booking/upcoming-booking.component";
import { AdvanceBookCouponsComponent } from "./advance-book-coupons/advance-book-coupons.component";
import { MapComponent } from "./map/map.component";
import { AllQueuersComponent } from "./all-queuers/all-queuers.component";
import { PayLaterPaymentComponent } from "./pay-later-payment/pay-later-payment.component";
import { PackageAddonComponent } from "./package-addon/package-addon.component";
import { LicenseComponent } from "./license/license.component";
import { SmtpFormComponent } from "./news-letter/smtp-form/smtp-form.component";
import { GoogleFormComponent } from "./news-letter/google-form/google-form.component";
import { NewsLetterComponent } from "./news-letter/news-letter.component";
import { NewsletterGuard } from "../shared/newsletterGaurd/newsletter-guard.guard";
import { CouponCodeComponent } from "./coupon-code/coupon-code.component";
import { WeatherSettingsComponent } from "./weather-settings/weather-settings.component";
import { WarningFeatureComponent } from "./warning-feature/warning-feature.component";
import { EmployeeComponent } from "./employee/employee.component";
import { InstantAccessDetailsComponent } from "./my-assets/instant-access-details/instant-access-details.component";
import { EmployeeDashboardComponent } from "./employee-dashboard/employee-dashboard.component";
import { AssetsComponent } from "./assets/assets.component";
import { UsersAdvanceBookingComponent } from "./users-advance-booking/users-advance-booking.component";
import { OutstandingAmountComponent } from "./outstanding-amount/outstanding-amount.component";
import { VendingComponent } from "./vending/vending.component";
import { MyAssignedAdvanceBookingComponent } from "./my-assigned-advance-booking/my-assigned-advance-booking.component";
import { VendingStoreComponent } from "./vending-store/vending-store.component";
import { FestivalsComponent } from "./festivals/festivals.component";
import { VendingTrackOrderComponent } from "./vending-track-order/vending-track-order.component";
import { VendingOrderDetailsComponent } from "./vending-order-details/vending-order-details.component";
import { LocationsComponent } from "./locations/locations.component";
import { BeachBookingComponent } from "./beach-booking/beach-booking.component";
import { BeachCreateBookingComponent } from "./beach-create-booking/beach-create-booking.component";
import { BeachBookingDetailComponent } from "./beach-booking-detail/beach-booking-detail.component";
import { VendingCouponComponent } from "./vending-coupon/vending-coupon.component";
import { ManageSpotComponent } from "./manage-spot/manage-spot.component";
import { ManageSpotDetailsComponent } from "./manage-spot-details/manage-spot-details.component";
import { ManageSpotRefundComponent } from "./manage-spot-refund/manage-spot-refund.component";
import { MembershipListComponent } from "./operator-membership/membership-list/membership-list.component";
import { UserMembershipComponent } from "./user-membership/user-membership.component";
import { UserMembershipDetailComponent } from "./user-membership-detail/user-membership-detail.component";
import { VendingCategoryComponent } from "./vending-category/vending-category.component";
import { ProductListsComponent } from "./vending-category/product-lists/product-lists.component";
import { VendingShippingFeatureComponent } from "./vending-shipping-feature/vending-shipping-feature.component";
import { LotteryComponent } from "./lottery/lottery.component";
import { LotteryParticipantsComponent } from "./lottery-participants/lottery-participants.component";
import { LotteryParticipantDetailsComponent } from "./lottery-participant-details/lottery-participant-details.component";
import { VendingDonationTransactionComponent } from "./vending-donation-transaction/vending-donation-transaction.component";
import { DonationDetailComponent } from "./vending-donation-details/vending-donation-details.component";
import { VendingDonationSettlementsComponent } from "./vending-donation-settlements/vending-donation-settlements.component";
import { DonationSettlementsDetailComponent } from "./vending-settlements-details/vending-settlements-details.component";
import { VendingDonationMasterComponent } from "./vending-donation-master/vending-donation-master.component";
import { PosTrackOrderComponent } from "./pos-track-order/pos-track-order.component";
import { PosOrderDetailsComponent } from "./pos-order-details/pos-order-details.component";

export const AdminRoutingModule: Routes = [
  {
    path: "",
    children: [
      {
        path: "dashboard",
        component: DashboardComponent,
        data: {
          title: "", //Dashboard
        },
      },
      {
        path: "assets",
        component: AssetsComponent,
        data: {
          title: "Assets",
          breadcrumb: [
            { title: "Home", url: "/user/dashboard" },
            { title: "Assets", url: "" },
          ],
        },
      },
      {
        path: "employee-dashboard",
        component: EmployeeDashboardComponent,
        data: {
          title: "Dashboard",
          breadcrumb: [],
        },
      },
      {
        path: "employee",
        component: EmployeeComponent,
        data: {
          title: "Employee List",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Employee List", url: "" },
          ],
        },
      },

      {
        path: "instant-access-details/:id",
        component: InstantAccessDetailsComponent,
        data: {
          title: "Instant Access",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Instant Access", url: "" },
          ],
        },
      },
      {
        path: "parking-violation/detail/:id",
        component: ParkingViolationDetailComponent,
        data: {
          title: "Parking Info",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Parking Violation", url: "user/parking-violation" },
            { title: "Parking Info" },
          ],
        },
      },

      {
        path: "geofence",
        component: GeofenceListComponent,
        data: {
          title: "Geofence",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Geofence", url: "" },
          ],
        },
      },
      {
        path: "geofence-map/:boundaryId",
        component: GeofenceMapComponent,
        data: {
          title: "Geofence",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Geofence Map", url: "/geofence-map/:boundaryId" },
          ],
        },
      },
      {
        path: "add-geofence-boundary",
        component: BoundaryComponent,
        data: {
          title: "Geofence",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Geofence", url: "user/geofence" },
            { title: "Add Geofence Boundary", url: "/add-geofence-boundary" },
          ],
        },
      },

      {
        path: "geofence/:id",
        component: BoundaryComponent,
        data: {
          title: "Geofence",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Geofence", url: "user/geofence" },
            { title: "Geofence", url: "/geofence/:id" },
          ],
        },
      },
      {
        path: "operation",
        component: OperationComponent,
        data: {
          title: "Put in Operation",
          subtitle:
            "Your payment will be confirmed and all your assets will be public",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Operation", url: "/operation" },
          ],
        },
      },
      {
        path: "operation/:paid",
        component: OperationComponent,
        data: {
          title: "Put in Operation",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Operation", url: "/operation/:paid" },
          ],
        },
      },
      {
        path: "business-profile",
        component: BusinessProfileComponent,
        data: {
          title: "Business profile",
          subtitle:
            "You will need to add some basic detail about your company to get started",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Business Profile", url: "/business-profile" },
          ],
        },
      },
      {
        path: "my-assets",
        component: MyAssetsComponent,
        data: {
          title: "My assets",
          subtitle:
            "Assets are bikes/scooters/boats which are embedded with scannable locks",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "My Assets", url: "/my-assets" },
          ],
        },
      },
      {
        path: "my-assets/detail/:id",
        component: DetailmyassetComponent,
        data: {
          title: "Asset detail",
          breadcrumb: [
            { title: "My Assets", url: "/my-assets" },
            { title: "Asset Detail", url: "" },
          ],
        },
      },
      {
        path: "business-analytics/:id",
        component: BusinessAnalyticsComponent,
        data: {
          title: "Business analytics",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "My Assets", url: "user/my-assets" },
            { title: "Business Analytics", url: "" },
          ],
        },
      },
      {
        path: "add-payment",
        component: AddPaymentComponent,
        data: {
          title: "Add Payment",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Add your payment account", url: "/add-payment" },
          ],
        },
      },
      {
        path: "rent-package",
        component: RentPackageComponent,
        data: {
          title: "Rent package",
          subtitle:
            "Bases on package bike will shared with user.You will earn from sharing",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Rent Package", url: "/rent-package" },
          ],
        },
      },
      {
        path: "request_payment",
        component: RequestPaymentComponent,
        data: {
          title: "Request Payment",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Request Payment", url: "/request_payment" },
          ],
        },
      },
      {
        path: "coupon_code",
        component: CouponCodeComponent,
        data: {
          title: "Coupon Code",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Coupon Code", url: "/coupon_code" },
          ],
        },
      },
      {
        path: "pay-later-payment",
        component: PayLaterPaymentComponent,
        data: {
          title: "Pay Later Payments",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Pay Later Payments", url: "/pay-later-payment" },
          ],
        },
      },
      {
        path: "book_package",
        component: LeasePackageComponent,
        data: {
          title: "Book Package",
          subtitle:
            "Customer will have asset access as an onwer for good duration.",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Book Package", url: "/book_package" },
          ],
        },
      },

      {
        path: "advance_booking",
        component: AdvanceBookingComponent,
        data: {
          title: "Advance Booking",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Advance Booking", url: "/advance_booking" },
          ],
        },
      },
      {
        path: "spot-booking",
        component: BeachBookingComponent,
        data: {
          title: "Spot Booking",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Spot Booking", url: "" },
          ],
        },
      },
      {
        path: "manage-spot-booking",
        component: ManageSpotComponent,
        data: {
          title: "Manage Spot Booking",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Manage Spot Booking", url: "" },
          ],
        },
      },
      {
        path: "manage-spot-details/:id",
        component: ManageSpotDetailsComponent,
        data: {
          title: "Manage Spot Details",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Manage Spot Booking", url: "user/manage-spot-booking" },
            { title: "Manage Spot Details", url: "" },
          ],
        },
      },
      {
        path: "manage-spot-refund",
        component: ManageSpotRefundComponent,
        data: {
          title: "Manage Spot Refund",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Manage Spot Refund", url: "" },
          ],
        },
      },
      {
        path: "spot-booking/create",
        component: BeachCreateBookingComponent,
        data: {
          title: "Spot Booking",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Spot Booking", url: "user/spot-booking" },
            { title: "Create", url: "" },
          ],
        },
      },
      {
        path: "spot-booking/details/:id",
        component: BeachBookingDetailComponent,
        data: {
          title: "Spot Booking details",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Spot Booking", url: "user/spot-booking" },
            { title: "details", url: "" },
          ],
        },
      },
      {
        path: "spot-booking/edit/:id",
        component: BeachCreateBookingComponent,
        data: {
          title: "Spot Booking",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Spot Booking", url: "user/spot-booking" },
            { title: "Edit", url: "" },
          ],
        },
      },

      {
        path: "package_addon",
        component: PackageAddonComponent,
        data: {
          title: "Package Addon",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Package Addon" },
          ],
        },
      },
      {
        path: "location_search",
        component: MapComponent,
        data: {
          title: "Location",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Location" },
          ],
        },
      },
      {
        path: "time-slot/:id",
        component: TimeSlotComponent,
        data: {
          title: "TimeSlot",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Advance Booking", url: "user/advance_booking" },
            { title: "TimeSlot", url: "" },
          ],
        },
      },
      {
        path: "all-queuers/:id",
        component: AllQueuersComponent,
        data: {
          title: "All Queuers",
          urls: [
            { title: "Home", url: "user/dashboard" },
            { title: "All Queuers" },
          ],
        },
      },
      {
        path: "sale-package",
        component: SalePackageComponent,
        data: {
          title: "Sale Package",
          subtitle:
            "Asset will transfer to user account.You are all access to asset will be removed",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Sale Package", url: "sale_package" },
          ],
        },
      },
      {
        path: "users-booking",
        component: UpcomingBookingComponent,
        data: {
          title: "Users Booking List",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Users Booking List", url: "" },
          ],
        },
      },
      {
        path: "users-advance-booking",
        component: UsersAdvanceBookingComponent,
        data: {
          title: "Users Advance Booking List",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Users Advance Booking List", url: "" },
          ],
        },
      },
      {
        path: "waiver",
        component: WaiverComponent,
        data: {
          title: "Waiver Term and conditions",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Waiver Term and conditions", url: "" },
          ],
        },
      },
      {
        path: "parking-violation/detail/:id",
        component: ParkingViolationDetailComponent,
        data: {
          title: "Parking Info",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Parking Violation", url: "user/parking-violation" },
            { title: "Parking Info" },
          ],
        },
      },

      {
        path: "external-api",
        component: ExternalApiComponent,
        data: {
          title: "External Apis",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "External Apis", url: "" },
          ],
        },
      },
      {
        path: "parking-violation",
        component: ParkingViolationComponent,
        data: {
          title: "Parking Violation",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Parking Violation", url: "" },
          ],
        },
      },
      {
        path: "rent-package/coupons",
        component: CouponsComponent,
        data: {
          title: "Package Coupons",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Rent Package", url: "user/rent-package" },
            { title: "Coupons", url: "" },
          ],
        },
      },
      {
        path: "sale-package/sale-coupons",
        component: SaleCouponsComponent,
        data: {
          title: "Package Coupons",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Sale Package", url: "user/sale-package" },
            { title: "Coupons", url: "" },
          ],
        },
      },
      {
        path: "book_package/book_coupons",
        component: LeaseCouponsComponent,
        data: {
          title: "Package Coupons",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Book Package", url: "user/book_package" },
            { title: "Coupons", url: "" },
          ],
        },
      },
      {
        path: "advance_booking/advance_book_coupons",
        component: AdvanceBookCouponsComponent,
        data: {
          title: "Package Coupons",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Advance Booking", url: "user/advance_booking" },
            { title: "Coupons", url: "" },
          ],
        },
      },
      {
        path: "used-coupons",
        component: UsedCouponsComponent,
        data: {
          title: "Used Coupon codes",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Used Coupon codes", url: "" },
          ],
        },
      },
      {
        path: "warning-feature",
        component: WarningFeatureComponent,
        data: {
          title: "Warning Feature",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Warning Feature", url: "" },
          ],
        },
      },
      {
        path: "waiver-forms",
        component: WaiverFormsComponent,
        data: {
          title: "Waiver forms (Customers)",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Waiver forms (Customers)", url: "" },
          ],
        },
      },
      {
        path: "track-assets",
        component: TrackAssetsComponent,
        data: {
          title: "Track assets",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Track assets", url: "" },
          ],
        },
      },
      {
        path: "purchase-history",
        component: PurchaseHistoryComponent,
        data: {
          title: "Purchase history",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Purchase history", url: "" },
          ],
        },
      },
      {
        path: "my-ride-history",
        component: RideHistoryComponent,
        data: {
          title: "My Ride History",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "My Ride History", url: "" },
          ],
        },
      },
      {
        path: "my-ride-history/detail/:id",
        component: DetailsComponent,
        data: {
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "My Ride History", url: "user/my-ride-history" },
            { title: "My Ride Info" },
          ],
        },
      },
      {
        path: "my-asset-ride-history",
        component: MyAssetRideHistoryComponent,
        data: {
          title: "My Asset Ride History",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "My Asset Ride History", url: "" },
          ],
        },
      },
      {
        path: "my-asset-ride-history/detail/:id",
        component: RideDetailsComponent,
        data: {
          title: "My Asset Ride History",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            {
              title: "My Asset Ride History",
              url: "user/my-asset-ride-history",
            },
            { title: "My Asset Ride Info" },
          ],
        },
      },
      {
        path: "my-book-history",
        component: LeaseHistoryComponent,
        data: {
          title: "My Book History",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "My Book History", url: "" },
          ],
        },
      },
      {
        path: "transactions",
        component: TransactionsComponent,
        data: {
          title: "Transactions",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Transactions", url: "" },
          ],
        },
      },
      {
        path: "pludda",
        component: PluddaComponent,
        data: {
          title: "Pludda",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Pludda", url: "" },
          ],
        },
      },
      {
        path: "pludda-details/:id",
        component: PluddaDetailsComponent,
        data: {
          title: "Pludda Details",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Pludda", url: "user/pludda" },
            { title: "Pludda Info" },
          ],
        },
      },
      {
        path: "lock-fallback",
        component: LockFallbackComponent,
        data: {
          title: "Lock Fallback History",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Lock Fallback History", url: "" },
          ],
        },
      },
      {
        path: "customer-review",
        component: CustomerReviewComponent,
        data: {
          title: "Customer Review",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Customer Review", url: "" },
          ],
        },
      },
      {
        path: "locations",
        component: LocationsComponent,
        data: {
          title: "Locations",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Locations", url: "" },
          ],
        },
      },
      {
        path: "notifications",
        component: NotificationsComponent,
        data: {
          title: "Notifications",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Notifications", url: "" },
          ],
        },
      },
      {
        path: "profile",
        component: ProfileComponent,
        data: {
          title: "Profile setting",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Profile setting", url: "" },
          ],
        },
      },

      {
        path: "term-conditions",
        component: TermConditionsComponent,
        data: {
          title: "Term & conditions",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Term & conditions", url: "" },
          ],
        },
      },
      {
        path: "privacy-policy",
        component: PrivacyPolicyComponent,
        data: {
          title: "Privacy & Policy",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Privacy & Policy", url: "" },
          ],
        },
      },
      {
        path: "payment-method",
        component: PaymentMethodComponent,
        data: {
          title: "Payments",
          subtitle: "Here you can manage your card for make payments",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Payments", url: "" },
          ],
        },
      },

      {
        path: "payment-method/:pay",
        component: PaymentMethodComponent,
        data: {
          title: "Payments",
          subtitle: "Here you can manage your card for make payments",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Payments" },
          ],
        },
      },
      {
        path: "pending-amount",
        component: OutstandingAmountComponent,
        data: {
          title: "Pending Amount",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Pending Amount", url: "" },
          ],
        },
      },
      // {
      //   path: "weather-setting",
      //   component: WeatherSettingsComponent,
      //   data: {
      //     title: "Weather Settings",
      //     breadcrumb: [
      //       { title: "Home", url: "user/dashboard" },
      //       { title: "Weather Settings", url: "" },
      //     ],
      //   },
      // },
      {
        path: "subscription",
        component: SubscriptionComponent,
        data: {
          title: "Subscription",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Subscription", url: "" },
          ],
        },
      },
      {
        path: "support/faq",
        component: FaqComponent,
        data: {
          title: "Help & FAQ",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Help & FAQ", url: "" },
          ],
        },
      },
      {
        path: "support/operator-support",
        component: OperatorSupportComponent,
        data: {
          title: "Operator support",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Operator support", url: "" },
          ],
        },
      },

      {
        path: "support/feedback",
        component: FeedbackComponent,
        data: {
          title: "Feedback",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Feedback", url: "" },
          ],
        },
      },
      {
        path: "waiver-terms/frekis",
        component: FrekisTermComponent,
        data: {
          title: "Frekis",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Frekis Waiver", url: "" },
          ],
        },
      },
      {
        path: "waiver-terms/sharekayak",
        component: SharekayakTermComponent,
        data: {
          title: "Sharekayak",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Sharekayak Waiver", url: "" },
          ],
        },
      },
      {
        path: "waiver-terms/shrvee",
        component: OdeTermComponent,
        data: {
          title: "Shrvee Services",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Shrvee Waiver", url: "" },
          ],
        },
      },
      {
        path: "license",
        component: LicenseComponent,
        data: {
          title: "License",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "License", url: "" },
          ],
        },
      },
      {
        path: "news-letter",
        component: NewsLetterComponent,
        data: {
          title: "Newsletter",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Newsletter", url: "" },
          ],
        },
      },
      {
        path: "vending-product",
        component: VendingComponent,
        data: {
          title: "Vending Product Info",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Vending Product Info", url: "" },
          ],
        },
      },
      {
        path: "vending-store/coupons",
        component: VendingCouponComponent,
        data: {
          title: "Vending Store Coupon",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            {
              title: "Vending Store",
              url: "user/vending-store",
            },
            { title: "Coupon Detail", url: "" },
          ],
        },
      },
      {
        path: "vending-store",
        component: VendingStoreComponent,
        data: {
          title: "Vending Store Info",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Vending Store Info", url: "" },
          ],
        },
      },
      {
        path: "festivals",
        component: FestivalsComponent,
        data: {
          title: "Festivals",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Festivals", url: "" },
          ],
        },
      },
      {
        path: "lottery",
        component: LotteryComponent,
        data: {
          title: "Lottery",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Lottery", url: "" },
          ],
        },
      },
      {
        path: "lottery-participants/:id",
        component: LotteryParticipantsComponent,
        data: {
          title: "Lottery Participants",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Lottery", url: "/user/lottery" },
            { title: "Participants", url: "" },
          ],
        },
      },
      {
        path: "lottery-participant-details/:id",
        component: LotteryParticipantDetailsComponent,
        data: {
          title: "Participant Details",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Lottery", url: "/user/lottery" },
            { title: "Participants", url: "/user/lottery-participants/:id" },
            { title: "Details", url: "" },
          ],
        },
      },
      {
        path: "express-shipping",
        component: VendingShippingFeatureComponent,
        data: {
          title: "Express shipping",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Express shipping", url: "" },
          ],
        },
      },
      {
        path: "charity-organization",
        component: VendingDonationMasterComponent,
        data: {
          title: "Charity Organization",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Charity Organization", url: "" },
          ],
        },
      },
      {
        path: "charity-transaction",
        component: VendingDonationTransactionComponent,
        data: {
          title: "Charity Transactions",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Charity Transactions", url: "" },
          ],
        },
      },
      {
        path: "charity-transaction/:id",
        component: DonationDetailComponent,
        data: {
          title: "Charity Transactions",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            {
              title: "Charity Transactions",
              url: "user/vending-donation-transaction",
            },
            { title: "Detail", url: "" },
          ],
        },
      },

      {
        path: "charity-settlements",
        component: VendingDonationSettlementsComponent,
        data: {
          title: "Charity Settlements",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Charity Settlements", url: "" },
          ],
        },
      },
      {
        path: "charity-settlements/:id",
        component: DonationSettlementsDetailComponent,
        data: {
          title: "Charity Settlements",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            {
              title: "Charity Settlements",
              url: "user/charity-settlements",
            },
            { title: "Detail", url: "" },
          ],
        },
      },
      {
        path: "vending-orders",
        component: VendingTrackOrderComponent,
        data: {
          title: "Vending Track Order Info",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Vending Track Order Info", url: "" },
          ],
        },
      },
      {
        path: "vending-orders/:id",
        component: VendingOrderDetailsComponent,
        data: {
          title: "Vending Track Order Info",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            {
              title: "Vending Order",
              url: "user/vending-orders",
            },
            { title: "Detail", url: "" },
          ],
        },
      },
      {
        path: "news-letter/smtp",
        component: SmtpFormComponent,
        canActivate: [NewsletterGuard],
        data: { guardCheck: true },
      },
      {
        path: "news-letter/google",
        component: GoogleFormComponent,
        canActivate: [NewsletterGuard],
        data: { guardCheck: true },
      },
      {
        path: "my-assigned-advance-booking",
        component: MyAssignedAdvanceBookingComponent,
        data: {
          title: "My assigned advance booking",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "My assigned advance booking", url: "" },
          ],
        },
      },
      {
        path: "membership",
        component: MembershipListComponent,
        data: {
          title: "Membership",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Membership", url: "" },
          ],
        },
      },
      {
        path: "user-membership",
        component: UserMembershipComponent,
        data: {
          title: "User Membership",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "User Membership", url: "" },
          ],
        },
      },
      {
        path: "user-membership/:id",
        component: UserMembershipDetailComponent,
        data: {
          title: "User Membership",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "User Membership", url: "user/user-membership" },
            { title: "Details", url: "" },
          ],
        },
      },
      {
        path: "vending-category",
        component: VendingCategoryComponent,
        data: {
          title: "Vending categories",
          breadcrumb: [
            { title: "Home", url: "user/dashboard" },
            { title: "Vending categories", url: "" },
          ],
        },
      },
      {
        path: "vending-category/products/:id",
        component: ProductListsComponent,
        data: {
          title: "Vending category products",
          breadcrumb: [
            { title: "Home", url: "/user/dashboard" },
            { title: "Vending categories", url: "user/vending-category" },
            { title: "Vending category products", url: "" },
          ],
        },
      },
      {
        path: "pos-orders",
        component: PosTrackOrderComponent,
        data: {
          title: "POS Order Info",
          breadcrumb: [
            { title: "Home", url: "/user/dashboard" },
            { title: "POS Order Info", url: "" },
          ],
        },
      },
      {
        path: "pos-orders/:id",
        component: PosOrderDetailsComponent,
        data: {
          title: "POS Order Details",
          breadcrumb: [
            { title: "Home", url: "/user/dashboard" },
            { title: "POS Order", url: "user/pos-orders" },
            { title: "Details", url: "" },
          ],
        },
      },
    ],
  },
];
